/**
 * Date / display formatters.
 *
 * Uses native Intl APIs to avoid pulling in date-fns / dateformat (legacy
 * admin had ~30KB of dateformat just to render "Wednesday, June 15, 2022").
 */

const fullDateFmt = new Intl.DateTimeFormat("en-US", {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
})

export function formatFullDate(value: string | number | Date | null | undefined): string {
  if (!value) return ""
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return ""
  return fullDateFmt.format(d)
}

/** ISO yyyy-mm-dd, suitable for `<input type="date" value=...>`. */
export function toIsoDate(value: string | number | Date | null | undefined): string {
  if (!value) return ""
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return ""
  return d.toISOString().slice(0, 10)
}
